export const css = {
	root: '_2K83Dd1-',
	header: '_3hUdGTiY',
	filterGroup: 'AQQ0dyIo',
	' _key': 'certwise-theme/dojo/grid'
};

export default css;
